import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { eventTypes } from '../data/eventTypes';
import { SectionHeading } from './SectionHeading';
export function ServicesSection() {
  const {
    language,
    t
  } = useLanguage();
  return <section id="services" className="bg-ivory px-5 py-24 md:px-8 md:py-32 lg:px-12" data-id="element-188" data-mp="2l8wu3785wxey">
      <div className="mx-auto max-w-[1200px]" data-id="element-189" data-mp="26kjt1vu7wodl">
        <SectionHeading kicker={t.services.kicker} headline={t.services.headline} data-id="element-190" data-mp="26jqo90etk8y3" />

        <div className="mt-16 border-t border-ink/15" data-id="element-191" data-mp="2bca98ifu66cx">
          {eventTypes.map((eventType, index) => <motion.article key={eventType.title.en} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          delay: index * 0.04,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid grid-cols-1 items-start gap-3 border-b border-ink/15 py-8 md:grid-cols-[0.9fr_1.1fr] md:gap-12 md:py-10" data-id="element-192" data-mp="1xl55b45fqrws" data-mpi={index}>
              <h3 className="font-display text-3xl leading-tight text-ink md:text-4xl" data-id="element-193" data-mp="2pn1b9q8umqji">{eventType.title[language]}</h3>
              <div className="max-w-lg" data-id="element-194" data-mp="2kozsz7j8yv93">
                <p className="text-base leading-relaxed text-ink/62" data-id="element-195" data-mp="2kqatmyhebmvz">{eventType.description[language]}</p>
                {eventType.detail ? <p className="mt-4 text-[11px] font-medium uppercase leading-5 tracking-[0.12em] text-ink/45" data-id="element-196" data-mp="2ume36pekunsy">{eventType.detail[language]}</p> : null}
                {eventType.note ? <p className="mt-4 font-display text-base italic text-burgundy" data-id="element-197" data-mp="26x1mz5ku1fh5">{eventType.note[language]}</p> : null}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}